import { SocialMedia, SocialMediaSearch } from "@shared/lib/types/influencer";
import pageStyles from "../styles.module.scss";
import { AddCreatorBar } from "../CreatorFitTab/AddCreatorBar";
import { ScriptCreatorTable } from "./ScriptCreatorTable";
import styles from "./styles.module.scss";
import { ScriptCreator } from "./types";

type IncomingCreator = Partial<SocialMedia> & Partial<SocialMediaSearch>;

export function ScriptGenerationList({
  creators,
  onAdd,
  onOpen,
  isBusy,
}: {
  creators: ScriptCreator[];
  onAdd: (creator: IncomingCreator) => void;
  onOpen: (id: string) => void;
  isBusy: boolean;
}) {
  const countLabel = `${creators.length} script${creators.length === 1 ? "" : "s"} in this project`;

  return (
    <div className={`${styles.list} ${pageStyles.creatorFitTab}`}>
      <section className={styles.panel}>
        <div className={styles.panelHead}>
          <div>
            <h2 className={styles.panelTitle}>Scripts</h2>
            <p className={styles.panelMeta}>{countLabel}</p>
          </div>
        </div>
        <div className={styles.panelBody}>
          <AddCreatorBar disabled={isBusy} onSubmit={onAdd} />
          <p className={styles.addHint}>
            Choose IG or YT, then select a suggestion. Each creator gets their
            own script.
          </p>
        </div>
        {creators.length === 0 ? (
          <div className={styles.empty}>
            <p className={styles.emptyTitle}>No scripts yet</p>
            <p className={styles.emptyCopy}>
              Add a creator above. You can add as many as you need in this
              project, then open one to write their script.
            </p>
          </div>
        ) : (
          <ScriptCreatorTable creators={creators} onOpen={onOpen} />
        )}
      </section>
    </div>
  );
}
